import styled, { keyframes } from 'styled-components';

const cubicBezier = `cubic-bezier(0.23, 1, 0.32, 1)`;
const opacity = `0.5`;

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: ${opacity};
  }
`;

export const StyledAnimatedPath = styled('path')`
  opacity: ${opacity};
  animation: ${fadeIn} 0.5s ${cubicBezier};
`;
